import { useState } from "react";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { FormInput } from "@/components/post/FormBits";
import { UploadBox } from "@/components/business/BusinessForm";

// Mobile TransferClaimForm: tell admin the transferred amount (+ optional receipt) -> POST /wallet/transfer-claims.
export function TransferClaimForm({ reference, lang, onClose, onSent }) {
  const L = (ar, en) => (lang === "ar" ? ar : en);
  const [amount, setAmount] = useState("");
  const [note, setNote] = useState("");
  const [receipt, setReceipt] = useState("");
  const [busy, setBusy] = useState(false);
  const send = async () => {
    const v = parseFloat(amount);
    if (!(v > 0)) { toast.error(L("أدخل المبلغ المحوَّل", "Enter the transferred amount")); return; }
    setBusy(true);
    try {
      await api.post("/wallet/transfer-claims", { amount: v, note, receipt });
      toast.success(L("تم إشعار الإدارة، وسيُضاف الرصيد بعد التحقق من الحوالة.", "Admin notified; your balance is added once the transfer is verified."));
      onSent();
    } catch (err) { toast.error(formatApiErrorDetail(err.response?.data?.detail)); }
    setBusy(false);
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent dir={lang === "ar" ? "rtl" : "ltr"} className="max-w-md" data-testid="transfer-claim-form">
        <DialogHeader><DialogTitle>{L("حوّلت المبلغ", "I have transferred")}</DialogTitle></DialogHeader>
        <p className="text-sm text-slate-600">{L(`بعد إتمام التحويل أخبرنا بالمبلغ وأرفق صورة الإيصال إن أمكن. سنطابق الحوالة برقمك المرجعي ${reference} ونضيف الرصيد.`, `After transferring, tell us the amount and attach the receipt if possible. We match it with your reference ${reference} and credit your wallet.`)}</p>
        <label className="text-sm font-semibold">{L("المبلغ المحوَّل (درهم)", "Transferred amount (AED)")}
          <FormInput className="mt-1" inputMode="decimal" dir="ltr" value={amount} onChange={(e) => setAmount(e.target.value.replace(/[^0-9.]/g, ""))} testid="claim-amount" /></label>
        <label className="text-sm font-semibold">{L("ملاحظة (اختياري)", "Note (optional)")}
          <FormInput className="mt-1" value={note} onChange={(e) => setNote(e.target.value)} placeholder={L("مثال: البنك، تاريخ التحويل", "e.g. bank, transfer date")} testid="claim-note" /></label>
        <UploadBox L={L} testid="claim-receipt" value={receipt} onChange={setReceipt} label={receipt ? L("تم إرفاق صورة الإيصال — اضغط للتغيير", "Receipt attached — tap to change") : L("إرفاق صورة الإيصال (اختياري)", "Attach receipt photo (optional)")} />
        <div className="flex gap-2">
          <button onClick={send} disabled={busy} className="flex-1 h-11 rounded-xl bg-[#1A5C3A] text-white font-bold flex items-center justify-center gap-2" data-testid="claim-submit">{busy && <Loader2 className="w-4 h-4 animate-spin" />}{L("إرسال إشعار الحوالة للإدارة", "Send transfer notice to admin")}</button>
          <button onClick={onClose} className="px-5 h-11 rounded-xl border font-bold" data-testid="claim-cancel">{L("إلغاء", "Cancel")}</button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
